import {Store,Module,ActionContext} from 'vuex'
import ListModule from '../list-module'
import ListState from '../list-state'
import Transaction from '../../entities/cashiers/transaction'
import Ajax from '../../../lib/ajax'
import Util from '../../../lib/util'
import url from '../../../lib/url'
import PageResult from '@/store/entities/page-result';
import axios from 'axios'

interface TransactionState extends ListState<Transaction>{
    editModel:Transaction;    
    opeModel:any;    
    activeList: Array<Transaction>;
    reportList: Array<any>;
    reportList2: Array<any>;
    methods: Array<any>;
    loadingNumber: boolean;
}
class TransactionModule extends ListModule<TransactionState,any,Transaction>{
    state={
        totalCount:0,
        currentPage:1,
        pageSize: 10,
        list: new Array<Transaction>(),
        loading:false,
        loadingNumber: false,
        editModel: new Transaction(),
        opeModel: null,
        activeList: new Array<Transaction>(),
        reportList: new Array<any>(),
        reportList2: new Array<any>(),
        methods: new Array<any>(),
        path: 'transactions'         
    }
    actions = Util.extend(true, this.base_actions, {
        //extra actions
        async getAll(context: ActionContext<TransactionState, any>, payload: any) {
            //if (payload.data.reference == undefined || payload.data.reference == '') return;
            context.state.loading = true;
            let reponse = await Ajax.get('/api/' + (context.state as any).path, { params: payload.data }).catch(e => {
                context.state.loading = false;
                return Promise.reject(e);
            });
            context.state.loading = false;
            let list = [];
            if (typeof reponse.data.result == 'object' && !Array.isArray(reponse.data.result)) {
                let page = reponse.data.result as PageResult<Transaction>;
                context.state.totalCount = page.total;
                list = page.data;
            } else {
                context.state.totalCount = reponse.data.result.length;
                list = reponse.data.result;
            }

            list.forEach((item, index) => {
                let state = Util.abp.list.getItem(item.state_id);
                if (state.code == 'R') 
                    item['class'] = ' removed_item';

                let mt = (payload.data.operation == 'purchase' || payload.data.operation == 'payableaccount' ? 'E' : 'I');

                item['color'] = (item.type == mt ? '#4CAF50' : '#F44336');
                item['amount_sign'] = (item.type == mt ? '' : '-') + String(item.amount);

                item.return_amount = item.amount;                
            });

            context.state.list = list;
        },
        async create(context: ActionContext<TransactionState, any>, payload: any) {
            context.state.loading = true;
            let response = await Ajax.post('/api/' + (context.state as any).path, payload.data).catch(e => {
                context.state.loading = false;
                return Promise.reject(e);
            });            
            let data = response.data.result;
            data['state'] = { 'name': 'Valido' };
            data['color'] = (data.type == 'I' ? '#4CAF50' : '#F44336');
            data['amount_sign'] = (data.type == 'I' ? '' : '-') + String(data.amount);
            context.state.list.push(data);
            context.state.totalCount = context.state.list.length;
            context.state.loading = false;
            return response.data.result;
        },
        async confirm(context: ActionContext<TransactionState, any>, payload: any) {
            context.state.loading = true;
            let response = await Ajax.post('/api/transactions/confirm', payload.data).catch(e => {
                context.state.loading = false;
                return Promise.reject(e);
            });
            context.state.loading = false;
            return response.data.result;
        },
        async delete(context: ActionContext<TransactionState, any>, payload: any) {
            let idx = -1;
            if (payload.data.id > 0) {
                context.state.loading = true;
                let id = payload.data.id;
                let reponse = await Ajax.delete('/api/' + (context.state as any).path + '/' + id).catch(e => {
                    context.state.loading = false;
                    return Promise.reject(e);
                });
                context.state.loading = false;
                context.state.list = reponse.data.result;
                context.state.list.forEach((item, index) => {
                    if (item['state'].code == 'R')
                        item['class'] = ' removed_item';
                });
                context.state.totalCount = context.state.list.length;

            } else {
                context.state.list.forEach((det, index) => {
                    if (det.amount == payload.data.amount && det.currency_id == payload.data.currency_id)
                        idx = index;
                });
                if (idx < 0) return;
                context.state.list.splice(idx, 1);
            }
        },
        async getLastCode(context: ActionContext<TransactionState, any>, payload: any) {
            let result = null;
            context.state.loadingNumber = true;
            await Ajax.get('/api/transactions/last-code').then(response => {
                result = response.data.result;
            }).catch(e => {
                result = '';
            });
            context.state.editModel.document_number = result;
            context.state.loadingNumber = false;
            return result;
        },
        async print(context: ActionContext<TransactionState, any>, payload: any) {
            context.state.loading = true;

            let response = await Ajax.get('/api/payment-receipt', { params: { id: payload.id } }).catch(e => {
                context.state.loading = false;
                return Promise.reject(e);
            });
            context.state.loading = false;

            let localUrl = Util.abp.setting.get('LOCAL_PRINTER_URL');
            let mode = Util.abp.setting.get('REMOTE_PRINTER_MODE');
            let method = Util.abp.setting.get('REMOTE_PRINTER_METHOD');
            let useRemote = Util.abp.setting.get('USE_REMOTE_PRINTER');

            if (mode == 'LOCAL' && useRemote == 1) {
                if (response.data.result.localUrl != undefined) localUrl = response.data.result.localUrl;
                if (method == 'POST') {
                    await axios.post(localUrl, response.data.result);
                } else {
                    let href: any = localUrl + "?endpoint=" + (url + 'api/payment-receipt') + "&token=" + window.abp.auth.getToken() + "&id=" + payload.id;
                    const link = document.createElement('a');
                    link.href = href;
                    link.target = '_blank';
                    document.body.appendChild(link);
                    link.click();
                    return '';
                    //await axios.get(localUrl, { params: response.data.result });
                }
                return '';
            } else
                return response.data.result;
        },
        async reportTransactionMoves(context: ActionContext<TransactionState, any>, payload: any) {
            context.state.loading = true;
            let reponse = await Ajax.get('/api/reports/transaction-moves', { params: payload.data }).catch(e => {
                context.state.loading = false;
                return Promise.reject(e);
            });
            context.state.loading = false;
            context.state.reportList = reponse.data.result;
        },
        async reportBalance(context: ActionContext<TransactionState, any>, payload: any) {
            context.state.loading = true;
            let reponse = await Ajax.get('/api/reports/transaction-balance', { params: payload.data }).catch(e => {
                context.state.loading = false;
                return Promise.reject(e);
            });
            context.state.loading = false;
            context.state.reportList2 = reponse.data.result.list;
            context.state.methods = reponse.data.result.methods;
        },
    });
    mutations = Util.extend(true, this.base_mutations, {
        //extra mutations
        new(state: TransactionState, model: any) {
            state.opeModel = model;
            //let document = state.editModel.document_number;
            state.editModel = Object.assign({});
            state.editModel.payment_date = Util.abp.clock.today();
            state.editModel.payment_method_id = Util.abp.setting.get('DEFAULT_PAYMENT_METHOD');
            state.editModel.currency_id = Util.abp.setting.get('DEFAULT_CURRENCY');
            state.editModel.currency_sign = Util.abp.setting.get('DEFAULT_CURRENCY_SIGN');
            if (state.editModel.document_number == null)
                state.editModel.document_number = '';
            state.editModel.nro_operation = '';
            state.editModel.amount = 0;
            state.editModel.change = 0;
            state.editModel.total_paid = 0;
            if (model != undefined) {                
                state.editModel.amount = model.balance;
            } else 
                state.editModel.amount = 0;

            if (model != undefined && model.currency_id != undefined && model.currency_id != state.editModel.currency_id) 
                state.editModel.currency_id = model.currency_id;
        },
        add(state: TransactionState, model: any) {
            if (state.list == undefined) state.list = [];
            model['color'] = (model.type == 'I' ? '#4CAF50' : '#F44336');
            model['amount_sign'] = (model.type == 'I' ? '' : '-') + String(model.amount);
            state.list.push(model);
            state.totalCount = state.list.length;
        },
        setReturns(state: TransactionState, amount: any) {
            state.list.forEach((item, index) => {
                if (amount == null)
                    item.return_amount = item.amount;
                else if (amount > 0) {
                    if (amount < item.amount) {
                        item.return_amount = amount;
                        amount = 0;
                    } else {
                        item.return_amount = item.amount;
                        amount -= item.amount;
                    }
                }
            });
        }
    });
}
const transactionModule=new TransactionModule();
export default transactionModule;